<template>
  <Box v-if="!isSecondaryTenant" class="col-span-full">
    <div class="flex flex-col gap-4">
      <CardLoaderSmall v-if="isLoading" class="flex-1 flex-col !p-0 !ring-0" />
      <template v-else>
        <h2 class="text-t4 mb-4 flex items-center gap-4">
          <IconInvoice class="w-[50px] h-[50px] md:w-[59px] md:h-[59px]" />
          Senaste fakturor
        </h2>
        <div class="flex flex-col gap-8">
          <div
            v-for="item in invoices.slice(0, 3)"
            class="relative flex items-center justify-between rounded-[8px] bg-gray-10 px-4 py-2 ring-1 ring-gray-light md:px-6 md:py-4"
          >
            <div class="flex gap-8">
              <p class="text-b2 md:text-b1">{{ dateFormat(item.ExpireDate) }}</p>
              <p class="text-b2 md:text-b1">{{ addSpace(item.InvoiceAmount) }} kr</p>
            </div>
            <Button variant="tertiary" size="small" :href="item.PdfLink" v-if="item.PdfLink">
              Visa som pdf
              <template #icon-after>
                <IconExternal />
              </template>
            </Button>

            <div class="text-label absolute -top-100 right-6" v-if="!!item.Cancelled || !!item.CreditInvoice">
                              <span
                                class="px-2 py-1 rounded-sm"
                                :class="'bg-green-light'"
                              >
                                {{ item.Cancelled ? 'Makulerad' : 'Kreditfaktura' }}
                              </span>
            </div>

            <div class="text-label absolute -top-100 right-6" v-else-if="!!item.Credited">
                              <span
                                class="px-2 py-1 rounded-sm"
                                :class="'bg-green-light'"
                              >
                                {{ 'Krediterad' }}
                              </span>
            </div>

            <div class="text-label absolute -top-100 right-6" v-else-if="expired(item) && unpaid(item)">
              <span
                class="px-2 py-1 rounded-sm"
                :class="'text-white bg-wine-red'"
              >
                {{ 'Förfallen' }}
              </span>
            </div>
            <div class="text-label absolute -top-100 right-6" v-else>
              <span
                class="px-2 py-1 rounded-sm"
                :class="unpaid(item) ? 'bg-primary-30' : 'bg-green-light'"
              >
                {{ unpaid(item) ? 'Obetald' : 'Betald' }}
              </span>
            </div>
          </div>
          <div v-if="invoices.length == 0">Du har inte några fakturor</div>
          <Button v-else variant="tertiary" :to="{ path: '/avtal-fakturor' }" class="self-end">
            Se alla fakturor
            <template #icon-after>
              <IconArrowRight />
            </template>
          </Button>
        </div>
      </template>
    </div>
  </Box>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import dayjs from 'dayjs';
import Modal from '@/components/ui/modal';
import Box from '@/components/ui/box';
import IconInvoice from '@/components/icons/IconInvoice';
import Button from '@/components/ui/button';
import IconExternal from '@/components/icons/IconExternal';
import IconArrowRight from '@/components/icons/IconArrowRight';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import GeneralMixin from '@/mixins/general';

export default {
  name: 'DashboardInvoices',
  mixins: [GeneralMixin],
  components: {
    Modal,
    Box,
    Button,
    IconExternal,
    IconInvoice,
    IconArrowRight,
    CardLoaderSmall,
  },
  props: {
    startLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loaded: [],
      isLoading: true,
      // testAlwaysLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      invoices: 'invoices',
    }),
    isSecondaryTenant() {
      return this.$store.getters.claims.some((el) => el == 'secondaryRentalContract');
    },
  },
  watch: {
    startLoading: {
      immediate: true,
      handler(val) {
        if (val === true) {
          this.$store.cache.dispatch('fetchInvoices').then((data) => {
            this.loaded.push('invoices');
            this.isLoading = false;
          });
        }
      }
    },
  },
  created() {
  },
  methods: {
    dateFormat(date) {
      return dayjs(date).format('YYYY-MM-DD');
    },
  },
};
</script>
